import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getToastStyle } from "./chunk-5XWPESX6.mjs";

// src/toast.component.tsx
import { useTimeout } from "@chakra-ui/react-use-timeout";
import { useUpdateEffect } from "@chakra-ui/react-use-update-effect";
import { runIfFn } from "@chakra-ui/shared-utils";
import { motion, useIsPresent } from "framer-motion";
import { chakra } from "@chakra-ui/system";
import { memo, useEffect, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var toastMotionVariants = {
  initial: function initial(props) {
    var position = props.position;
    var dir = ["top", "bottom"].includes(position) ? "y" : "x";
    var factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
    if (position === "bottom") factor = 1;
    return _defineProperty({
      opacity: 0
    }, dir, factor * 24);
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var ToastComponent = memo(function (props) {
  var id = props.id,
    message = props.message,
    onCloseComplete = props.onCloseComplete,
    onRequestRemove = props.onRequestRemove,
    _props$requestClose = props.requestClose,
    requestClose = _props$requestClose === void 0 ? false : _props$requestClose,
    _props$position = props.position,
    position = _props$position === void 0 ? "bottom" : _props$position,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 5e3 : _props$duration,
    containerStyle = props.containerStyle,
    _props$motionVariants = props.motionVariants,
    motionVariants = _props$motionVariants === void 0 ? toastMotionVariants : _props$motionVariants,
    _props$toastSpacing = props.toastSpacing,
    toastSpacing = _props$toastSpacing === void 0 ? "0.5rem" : _props$toastSpacing;
  var _useState = useState(duration),
    _useState2 = _slicedToArray(_useState, 2),
    delay = _useState2[0],
    setDelay = _useState2[1];
  var isPresent = useIsPresent();
  useUpdateEffect(function () {
    if (!isPresent) {
      onCloseComplete == null ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  useUpdateEffect(function () {
    setDelay(duration);
  }, [duration]);
  var onMouseEnter = function onMouseEnter() {
    return setDelay(null);
  };
  var onMouseLeave = function onMouseLeave() {
    return setDelay(duration);
  };
  var close = function close() {
    if (isPresent) onRequestRemove();
  };
  useEffect(function () {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  useTimeout(close, delay);
  var containerStyles = useMemo(function () {
    return _objectSpread({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: toastSpacing
    }, containerStyle);
  }, [containerStyle, toastSpacing]);
  var toastStyle = useMemo(function () {
    return getToastStyle(position);
  }, [position]);
  return /* @__PURE__ */jsx(motion.li, {
    layout: true,
    className: "chakra-toast",
    variants: motionVariants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    onHoverStart: onMouseEnter,
    onHoverEnd: onMouseLeave,
    custom: {
      position: position
    },
    style: toastStyle,
    children: /* @__PURE__ */jsx(chakra.div, {
      role: "status",
      "aria-atomic": "true",
      className: "chakra-toast__inner",
      __css: containerStyles,
      children: runIfFn(message, {
        id: id,
        onClose: close
      })
    })
  });
});
ToastComponent.displayName = "ToastComponent";
export { ToastComponent };